import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router'

import { EMPTY_STRING } from '../../../constants/common'
import {
  SEARCH_RESULTS_QUERY_PARAM_BY_TABLE,
  URL_ALIASES,
} from '../../../constants/route'
import { useInitData, useLogin } from '../../../hooks'
import { getApi, postApi } from '../../../utils/api'
import { Loader } from '../../Loader'
import { setSearchFilterSkipReset } from '../../SearchResults'

import { getAdditionalFiltersQuery } from './FilterState.utils'

function FilterState() {
  const navigate = useNavigate()

  const { filterStateKey } = useParams()

  const { authorized } = useInitData()

  useLogin()

  useEffect(() => {
    if (filterStateKey && authorized) {
      postApi({
        endpoint: `/idwell-api/api/v3/table/shared-filter-states/${filterStateKey}/apply/`,
      })
        .then(({ data }) => {
          const {
            object_id,
            page,
            required_filter_values,
            sub_menu,
            table_name,
          } = data

          const searchParamKey = SEARCH_RESULTS_QUERY_PARAM_BY_TABLE[table_name]

          // Search-results tables: `apply` writes the shared filters into the user's own
          // filter-state server-side and returns only navigation data — the filters and the
          // search term are not in the response. So fetch the persisted state to read the
          // search term (stored in `meta`) and rebuild the results URL with it; the filters
          // themselves are loaded by the results page. The skip-reset flag keeps the
          // just-applied filters from being reset as a "fresh search" on arrival.
          if (searchParamKey) {
            setSearchFilterSkipReset(table_name, sub_menu)

            function goToResults(searchQuery) {
              const querySegment = searchQuery
                ? `&${searchParamKey}=${encodeURIComponent(searchQuery)}`
                : EMPTY_STRING

              navigate(
                `${URL_ALIASES[table_name]}?page=${page}${querySegment}`,
                {
                  replace: true,
                  state: {
                    table_name,
                  },
                }
              )
            }

            return getApi({
              endpoint: `idwell-api/api/v3/table/filter-states/${table_name}/${sub_menu}/`,
            })
              .then(({ data: filterState }) => {
                goToResults(
                  filterState?.meta?.search_query ?? filterState?.search_query
                )
              })
              .catch(() => goToResults())
          }

          const profileId = object_id ? `${object_id}/` : EMPTY_STRING

          const additionalFilters = getAdditionalFiltersQuery(
            required_filter_values
          )

          navigate(
            `${URL_ALIASES[table_name]}${profileId}?page=${page}&sub=${sub_menu}${additionalFilters}`,
            {
              replace: true,
              state: {
                table_name,
              },
            }
          )
        })
        .catch(() => {
          navigate('/', { replace: true })
        })
    }
  }, [authorized, filterStateKey, navigate])

  return <Loader />
}

export default FilterState
